import { useEffect } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
import '../../assets/styles/compliance/DoughnutChart.scss';
import { theme } from '../../theme';

function DoughnutChart({parentToChild}) {

  const { mode, complianceData } = parentToChild;

  var CanvasJSChart = CanvasJSReact.CanvasJSChart;

  const options = {
    backgroundColor: mode === 'light' ? 'white': '#201c24',
    animationEnabled: true,
    subtitles: [{
      text: complianceData ? `${parseFloat(complianceData['total_calls']).toFixed(0)}` : '0',
      verticalAlign: "center",
      fontSize: 50,
      fontColor: mode === 'light' ? 'black': 'white',
      dockInsidePlotArea: true,
      fontFamily: theme.fonts.secondary,
    }],
    data: [{
      type: "doughnut",
      // showInLegend: true,
      indexLabel: "{y}",
      indexLabelPlacement: "inside",
      indexLabelFontColor: "white",
      yValueFormatString: "#,###''",
      // yValueFormatString: "#,###'K'",
      fontFamily: theme.fonts.primary,
      dataPoints: [
          { name: "Payment", y: 10, color: '#2e2e38' },
          { name: "Transaction", y: 20, color: '#c4c4cd' },
          { name: "Credit Line", y: 30, color: '#c8b424' },
          { name: "Balance Transfer", y: 40, color: theme.colors.primary }
      ]
    }]
  }

  const listData = [
    { name: "Payment", color: '#2e2e38' },
    { name: "Transaction", color: '#c4c4cd' },
    { name: "Credit Line", color: '#c8b424' },
    { name: "Balance Transfer", color: theme.colors.primary },
  ];

  useEffect(() => {
    const list = document.getElementById('list');
    if (list) {
      list.innerHTML = '';
      listData.forEach((item, index) => {
        const listItem = document.createElement('li');
        listItem.textContent = item.name;
        listItem.innerHTML += `<style>ul li:nth-child(${index + 1})::before { background-color: ${item.color} }</style>`;
        list.appendChild(listItem);
      });
    }
    // eslint-disable-next-line
  }, []);

  const containerProps = {
      height: "270px",
      width: "100%",
  };

  return (
    <div className='canvasjs-chart'>
      <CanvasJSChart containerProps={containerProps} options = {options}
          /* onRef={ref => this.chart = ref} */
      />
      {/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
      <ul id="list"></ul>
    </div>
  );
}

export default DoughnutChart;